import React from "react";
import styles from "./ImagePickerMainWrapper.module.css";

function ImagePickerMainWrapper({ children, isGrid }) 
{
    return <div className={`${isGrid ? styles.gridContainer : styles.container}`}>{children}</div>;
}

export default ImagePickerMainWrapper;
